var cartCount = $('.cart-count');
var cartTotal = $('.cart-total');
var cartContainer = $('#cart-sidebar .sidebar-content');
var cartFooter = $('.cart-footer');
var cartFooterEmpty = $('.cart-footer-empty');
var cartDelBtn = '.remove-from-cart';

function updateDom(cart){
    cartContainer.html('');
    if( cartCount.length && cart.item_count !== 0){
        cartCount.css({
            "visibility": "visible",
            "opacity": "1"
        })
        cartCount.each(function(){
            $(this).text(cart.item_count);
        })
    }else {
        cartCount.css({
            "visibility": "hidden",
            "opacity": "0"
        })
    }

    if( cartTotal.length && cart.item_count !== 0){
        cartTotal.each(function(){
            $(this).text('( '+ Shopify.formatMoney(cart.total_price)+ ' )');
        })
    }

    if( cartContainer.length && cart.item_count !== 0){
        jQuery.each( cart.items, function( i, item ) {
            cartContainer.append( 
                `
                <div class="menu-card mb-4 d-flex justify-content-between">
                    <div class="d-flex">
                        <a href="${item.url}" class="image border p-2 mr-2 flex-img">
                            <img src="${item.image}" alt="" class="w-100">
                        </a>
                        <div class="item-info ps-3">
                            <a href="${ item.url}" class="fs-16 fw-600">${item.title}</a>
                            <p class="fs-14">price: <strong>${Shopify.formatMoney(item.price)} (${item.quantity})</strong></p> 
                             <button class="remove-from-cart btn btn-sm px-1 fs-14" data-id="${item.id}">
                                <img src="//luxara.com.au/cdn/shop/t/22/assets/trash.svg?v=166718643063612703111758637412" alt="">
                            </button>
                        </div>
                    </div>
                </div>
                `
            );
        });

        if(cartFooter.hasClass('d-none')){
            cartFooter.removeClass('d-none');
        }
        if(!cartFooterEmpty.hasClass('d-none')){
            cartFooterEmpty.addClass('d-none');
        }
    }else {
        cartContainer.append(`
            <div class="d-flex flex-column justify-content-center align-items-center py-5">
                <div class="image w-100 w-md-75 d-flex justify-content-center">
                    <img src="//luxara.com.au/cdn/shop/t/22/assets/empty-cart.png?v=133486816048278602751758637412" />
                </div>
                <h3 class="fs-24 fw-600 text-center">Cart is currently empty</h3>
            </div>
        `)
        cartFooter.addClass('d-none');
        cartFooterEmpty.removeClass('d-none');
    }
}

function getCart(){
    jQuery.getJSON('/cart.js', function(cart) {
        updateDom(cart);
    });
}

function addCart() {
    if($('.ajax-cart-form').length){
        $('.ajax-cart-form').on('submit',function(e){
            var form = $(this);
            e.preventDefault();
            var btn = $(this).find('button[type="submit"]');
            btn.prop("disabled",true);
            btn.css({
                "opacity": ".7"
            })
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: form.serialize(),
                dataType: 'json'
            }).done(function(cart) {
                console.log('cart:', cart)
                btn.prop("disabled",false);
                btn.css({
                    "opacity": "1"
                })

                getCart();

                alertify.success('Added To Cart')
                
            }).fail(function(res) {
                if(res.status == 422){
                    alertify.error(res.responseJSON.description)
                }
            })

        })
    }   
}

function removeCartItem (){
    $(document).on("click", cartDelBtn, function(e){
        e.preventDefault();

        var productId = $(this).attr('data-id');

        jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                quantity: 0,
                id: productId
            },
            dataType: 'json'
        }).done(function() {

            getCart();
            alertify.success('Item removed')

        }).fail(function(res) {
            if(res.status == 422){
                alert(res.responseJSON.description);
            }
        })

    })
}

(function ($) {
    "use strict";
    $(window).on('load', function () {
        getCart();
        addCart();
        removeCartItem();
    });

})(window.jQuery);